import InfoCard from '../../../InfoCard/InfoCard';
import Loading from '../../../Loading/Loading';
import Show from '../../../Show/Show';
import SurveyButton from '../../../Survey/SurveyButton';
import { AnswerSelectPresentationProps } from '../config';
import { COLORS } from '../../../../config/designSystem/Colors';
import { FC } from 'react';
import { ParagraphLRegular, ParagraphSBold } from '../../../../config/designSystem/typography';
import { ScrollView, StyleSheet } from 'react-native';
import { View } from 'react-native-animatable';
import { observer } from 'mobx-react';
import { useAnswerWidth } from '../useAnswerWidth';

const _PresentVerifyText: FC<AnswerSelectPresentationProps> = ({
  answers,
  onPress,
  labels,
  loading,
}) => {
  const width = useAnswerWidth();
  const lastAnswer = answers?.[0]? answers[0] : null;
  const error = labels?.ERROR;
  const warning = labels?.WARNING;
  const label = labels?.LABEL;

  return (
    <View style={styles.center}>
      <ScrollView
        contentContainerStyle={styles.scrollView}
        showsVerticalScrollIndicator={false}
      >
        <Show when={!loading && !error} fallback={loading && <Loading/>} >
          <ParagraphLRegular>{label}</ParagraphLRegular>
          {answers?.slice(1)?.map(answer => (
            <ParagraphSBold
              key={answer._id}
            >
              {answer.wording}
            </ParagraphSBold>
          ))}
        </Show>
        <Show when={lastAnswer} keyed>
          {answer => (
            <SurveyButton
              selectType={'one'}
              title={lastAnswer!.wording || ''}
              backgroundColor={'transparent'}
              textColor={COLORS.content.accent}
              onPress={() => onPress(answer)}
              inSession={true}
              WIDTH={width *0.8}
            />
          )}
        </Show>
        <Show when={error} keyed>
          {info => (
            <InfoCard
              type="error"
              info={info}
            />
          )}
        </Show>
        <Show when={warning} keyed>
          {info => (
            <InfoCard
              type="warn"
              info={info}
            />
          )}
        </Show>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  center: {
    justifyContent: 'center',
  },
  scrollView: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 10,
    justifyContent: 'center',
    alignItems: 'center',
  }
});

export const PresentVerifyText = observer(_PresentVerifyText);

